import Bridge from 'src/frontend-lib/lib/Bridge'
import Mp from '../libs/Mp'
import { getRunTime, getSystem } from '../libs/utils'

// never used
// const wechatLibSrc = `https://res.wx.qq.com/open/js/jweixin-1.3.2.js`

const bridgeMixin = {
  computed: {
    mixinIsApp() {
      return this.platform.isYixinliApp || this.platform.isZiXunApp
    },

    mixinIsMp() {
      return Mp.isMp
    },

    mixinMp() {
      return new Mp()
    },

    staticSite() {
      // static站url
      return (
        location.protocol +
        getRunTime('//static.xinli001.com') +
        location.pathname
      )
    }
  },
  methods: {
    // 担心历史问题有些没有改到，保留
    // getBrige() {
    //   return this.getBridge()
    // },
    getBridge() {
      if (!this.bridge) {
        this.bridge = new Bridge()
      }
      return this.bridge
    },
    /**
     * 打开新的页面，在app中如果isCurrentPageOpen===0会新开webview
     * @param {*} options http://112.124.122.87:8090/pages/viewpage.action?pageId=3311963#id-%E5%A3%B9%E5%BF%83%E7%90%86appnative&h5%E6%8E%A5%E5%8F%A3-openWebView(url)
     */
    /*eslint-disable*/
    openWebView(options = {}) {
      if (!options.url) {
        throw new Error('openWebView需要url参数挂载在options上')
      }
      options = {
        isCurrentPageOpen: 0,
        ...options
      }

      const appVersion = this.$route.query._version
        ? this.$route.query._version
        : null

      if (this.platform.isYixinliApp || this.platform.isZiXunApp) {
        const myBridge = this.getBridge()
        if (
          appVersion &&
          ('4.9.4' >= appVersion && getSystem() === 'Android') &&
          this.platform.isYixinliApp
        ) {
          myBridge.call(
            'openWebView',
            encodeURIComponent(JSON.stringify(options))
          )
        } else {
          myBridge.call('openWebView', options)
        }
        // window.location.href = options.url;a
      } else {
        window.location.href = options.url
      }
    },

    navTo(options) {
      if (this.mixinIsMp) {
        this.mixinMp.openWebView(options)
      } else {
        this.openWebView(options)
      }
    },

    /**
     * 关闭当前页面
     */
    cancelWebView() {
      if (this.mixinIsApp) {
        this.getBridge().call('cancelWebView')
      } else {
        window.history.back()
      }
    },

    navBack() {
      if (this.mixinIsMp) {
        this._loadWxForMp().then(() => {
          this.mixinMp.cancelWebView()
        })
      } else {
        this.cancelWebView()
      }
    },

    /**
     * 设置标题
     * @param {*} navTitle
     */
    setNavTitle(navTitle) {
      if (this.mixinIsApp) {
        var myBridge = this.getBridge()
        myBridge.call('setTitle', { title: navTitle })
      } else {
        document.querySelector('title').innerText = navTitle
      }
    }
  }
}

export default bridgeMixin



// WEBPACK FOOTER //
// ./src/mixins/bridge.js